 // Start of Selection
import React, { useState, useEffect } from 'react';

const NodeDictDisplayComponent = ({ nodeDict, imageWidth, imageHeight, scale, geoToPixel }) => {

// console.log("nodeDict in NodeDictDisplayComponent", nodeDict)

  const [pixelNode, setPixelNode] = useState([]);
  
  useEffect(() => {
    if (typeof geoToPixel === 'function' && nodeDict && nodeDict.length > 0) {
      const convertedPath = nodeDict.map(p => geoToPixel(p.x, p.y));
          // Start of Selection
          setPixelNode(convertedPath.map((point, index) => {
            const headingStr = nodeDict[index].heading;
            const [h0, h1] = [parseFloat(headingStr[0]), parseFloat(headingStr[1])];
            return {
              id: nodeDict[index].id,
              heading: [h0, h1],
              x: point[0],
              y: point[1],
            };
          }));
    } else {
      setPixelNode([]);
    }
  }, [geoToPixel, nodeDict]);

  const getHeading = (heading) => {
    const heading_float = parseFloat(heading);
    // Adjust for SVG coordinate system and add 90 degrees to correct the offset
    return (heading_float + 180) % 360;
  }

  if (!nodeDict || nodeDict.length === 0 || !geoToPixel) return null;
//   console.log("pixelNode in NodeDictDisplayComponent", pixelNode)
  const arrowSize = Math.max(25, 50 / scale);
  const arrowPath = `M -${arrowSize/2} -${arrowSize/6} L ${arrowSize/2} 0 L -${arrowSize/2} ${arrowSize/6} Z`;
  const textSize = Math.max(12, 12 / scale); // Adjust text size based on scale
//   console.log("pixelNode in NodeDictDisplayComponent", pixelNode)
  return (
    <svg width={imageWidth} height={imageHeight} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}>
      {pixelNode.map((point, index) => (
        <React.Fragment key={index}>
          <circle
            cx={point.x}
            cy={point.y}
            r={Math.max(5, 10 / scale)}
            fill="black"
            stroke="black"
            strokeWidth={Math.max(2, 4 / scale)}
          />
          <rect
            x={point.x - textSize * 3}
            y={point.y - textSize * 3}
            width={textSize * 6}
            height={textSize * 2.5}
            fill="white"
          />
          <text
            x={point.x}
            y={point.y - textSize}
            fontSize={textSize*1.5}
            fill="black"
            textAnchor="middle"
          >
            {point.id}
          </text>
          {/* Add Heading Arrows */}
          <path
            d={arrowPath}
            fill="cyan"
            stroke="cyan"
            strokeWidth={Math.max(2, 4 / scale)}
            transform={`translate(${point.x}, ${point.y}) rotate(${getHeading(point.heading[0])})`}
          />
          <path
            d={arrowPath}
            fill="magenta"
            stroke="magenta"
            strokeWidth={Math.max(2, 4 / scale)}
            transform={`translate(${point.x}, ${point.y}) rotate(${getHeading(point.heading[1])})`}
          />
        </React.Fragment>
      ))}
    </svg>
  );
};

export default NodeDictDisplayComponent;